import { FC } from 'react';
import { Skeleton, VStack } from '@chakra-ui/react';

import SunshineCard from 'components/_core/SunshineCard';

import { DeltaValueHeader } from '../../../components/DeltaValueHeader';
import { EvolutionColorSchema } from '../../../components/DeltaValueHeader/types';

interface GraphSelectorProps {
  empty: boolean;
  evolutionColorSchema?: EvolutionColorSchema | null;
  title: string;
  newTotal?: number;
  oldTotal?: number;
  onClick: () => void;
  isSelected: boolean;
  isLoading: boolean;
  displayArrow?: boolean;
}

export type GraphType = 'balance' | 'payin' | 'payout';

const GraphSelector: FC<GraphSelectorProps> = ({
  displayArrow = false,
  empty,
  evolutionColorSchema = 'normal',
  isLoading,
  isSelected,
  newTotal,
  oldTotal,
  onClick,
  title,
}) => {
  if (isLoading) {
    return (
      <VStack
        alignItems="stretch"
        border="1px solid"
        borderColor="card-borderColor"
        borderRadius="radius-8"
        height="120px"
        justifyContent="space-evenly"
        padding="space-16"
      >
        <Skeleton
          borderRadius="radius-4"
          endColor="grey.300"
          height="14px"
          startColor="grey.100"
          width="116px"
        />

        <Skeleton
          borderRadius="radius-4"
          endColor="grey.300"
          height="24px"
          startColor="grey.100"
          width="162px"
        />
      </VStack>
    );
  }

  return (
    <SunshineCard
      border="1px solid"
      borderColor={
        isSelected ? 'card-borderColor-selected' : 'card-borderColor'
      }
      isActive={isSelected}
      onClick={onClick}
      padding="space-16"
      paddingBottom={empty ? 'space-8' : 'space-16'}
    >
      <DeltaValueHeader
        backgroundColor="unset"
        borderBottom="none"
        currentValue={empty ? 0 : newTotal}
        displayArrow={displayArrow}
        evolutionColorSchema={evolutionColorSchema}
        padding="unset"
        previousValue={empty ? undefined : oldTotal}
        title={title}
      />
    </SunshineCard>
  );
};

export default GraphSelector;
